module.exports = __webpack_public_path__ + "img/arrow-down-left.05035ca9.svg";